export function getDatetimeIndex(input) {
  const date = input || new Date()
  return {
    hour_of_day: date.getHours(),
    day_of_week: Number.parseInt(1 + date.getDay()),
    day_of_month: date.getDate(),
    month: Number.parseInt(1 + date.getMonth()),
    year: date.getFullYear(),
  }
}
